export default __webpack_public_path__ + "images/a98efc4070bc12feeb23c63a516119ac.svg";